import { render, staticRenderFns } from "./patientstaticinformation.vue?vue&type=template&id=80e52888&scoped=true&"
import script from "./patientstaticinformation.vue?vue&type=script&lang=js&"
export * from "./patientstaticinformation.vue?vue&type=script&lang=js&"
import style0 from "./patientstaticinformation.vue?vue&type=style&index=0&id=80e52888&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e52888",
  null
  
)

export default component.exports